import React from "react";
import { FaCalendarAlt, FaCreditCard, FaSave } from "react-icons/fa";

function SkeletonCard() {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="space-y-4 p-5">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="h-14 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800"
          />
        ))}
      </div>
    </section>
  );
}

export default function PaiementSettingsCard({
  formId,
  settings,
  loading,
  saving,
  onChange,
  onSubmit,
}) {
  if (loading) return <SkeletonCard />;

  return (
    <form
      id={formId}
      onSubmit={onSubmit}
      className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
    >
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5">
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
            Échéancier
          </p>

          <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
            <FaCreditCard className="text-indigo-600 dark:text-indigo-300" />
            Règlement en plusieurs fois
          </h3>

          <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
            Ces paramètres contrôlent le règlement fractionné de la partie
            Licence-Assurance & Cotisation.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Nombre maximum de paiements
            </label>

            <select
              name="max_payments"
              value={settings.max_payments}
              onChange={onChange}
              className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
            >
              {[1, 2, 3, 4, 5].map((value) => (
                <option key={value} value={value}>
                  {value} paiement{value > 1 ? "s" : ""}
                </option>
              ))}
            </select>

            <p className="mt-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
              Exemple : 3 paiements permet de proposer un règlement en 1, 2 ou
              3 fois.
            </p>
          </div>

          <div>
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Espacement des paiements
            </label>

            <div className="relative">
              <FaCalendarAlt className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

              <select
                name="payment_interval"
                value={settings.payment_interval}
                onChange={onChange}
                className="w-full rounded-2xl border border-slate-200 bg-white py-2.5 pl-10 pr-3 text-sm font-medium text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
              >
                {[1, 2, 3].map((value) => (
                  <option key={value} value={value}>
                    Tous les {value} mois
                  </option>
                ))}
              </select>
            </div>

            <p className="mt-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
              Exemple : tous les 1 mois = échéances mensuelles.
            </p>
          </div>
        </div>

        <div className="mt-6 rounded-[24px] border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-500/20 dark:bg-indigo-500/10">
          <p className="text-sm font-bold text-indigo-800 dark:text-indigo-200">
            Aperçu de la configuration actuelle
          </p>

          <p className="mt-1 text-sm leading-6 text-indigo-700 dark:text-indigo-300">
            Le club peut proposer jusqu’à{" "}
            <strong>{settings.max_payments}</strong> paiement
            {Number(settings.max_payments) > 1 ? "s" : ""}, espacés de{" "}
            <strong>{settings.payment_interval}</strong> mois.
          </p>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] disabled:cursor-not-allowed disabled:opacity-60 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          >
            <FaSave />
            {saving ? "Enregistrement..." : "Mettre à jour"}
          </button>
        </div>
      </div>
    </form>
  );
}